import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberVertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronGrabberVertical"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 3.93945L17.0608 9.00011L16.0001 10.0608L12.0001 6.06077L8.00011 10.0608L6.93945 9.00011L12.0001 3.93945ZM8.00011 13.9395L12.0001 17.9395L16.0001 13.9395L17.0608 15.0001L12.0001 20.0608L6.93945 15.0001L8.00011 13.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberVertical;
